import type { Editor } from '@tiptap/core';

type TiptapTextStyleChain = ReturnType<Editor['chain']> & {
  setBackgroundColor: (value: string) => TiptapTextStyleChain;
  setColor: (value: string) => TiptapTextStyleChain;
  setFontFamily: (value: string) => TiptapTextStyleChain;
  setFontSize: (value: string) => TiptapTextStyleChain;
  unsetFontFamily: () => TiptapTextStyleChain;
  unsetFontSize: () => TiptapTextStyleChain;
};

const getChain = (editor: Editor): TiptapTextStyleChain => {
  return editor.chain().focus() as unknown as TiptapTextStyleChain;
};

export const setFontFamily = (editor: Editor, value: string) => {
  getChain(editor).setFontFamily(value).run();
};

export const unsetFontFamily = (editor: Editor) => {
  getChain(editor).unsetFontFamily().run();
};

export const setFontSize = (editor: Editor, value: string) => {
  getChain(editor).setFontSize(value).run();
};

export const unsetFontSize = (editor: Editor) => {
  getChain(editor).unsetFontSize().run();
};

export const setTextColor = (editor: Editor, value: string) => {
  getChain(editor).setColor(value).run();
};

export const setHighlightColor = (editor: Editor, value: string) => {
  getChain(editor).setBackgroundColor(value).run();
};
